import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube, Phone, MapPin, Mail } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-sage-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-serif mb-4">Healing-Women</h3>
            <p className="text-sage-200 text-sm leading-relaxed mb-4">
              Supporting women through breast implant illness and the explant journey with compassion and expertise.
            </p>
            <div className="flex space-x-3">
              <a
                href={mockData.siteInfo.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-sage-800 rounded-lg hover:bg-sage-700 transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={mockData.siteInfo.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-sage-800 rounded-lg hover:bg-sage-700 transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={mockData.siteInfo.socialMedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-sage-800 rounded-lg hover:bg-sage-700 transition-colors"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href={mockData.siteInfo.socialMedia.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-sage-800 rounded-lg hover:bg-sage-700 transition-colors"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sage-200 hover:text-white text-sm transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sage-200 hover:text-white text-sm transition-colors">
                  About Lindsey
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-sage-200 hover:text-white text-sm transition-colors">
                  Book a Session
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sage-200 hover:text-white text-sm transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-sage-200 hover:text-white text-sm transition-colors">
                  My Book
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/qa" className="text-sage-200 hover:text-white text-sm transition-colors">
                  Q&A
                </Link>
              </li>
              <li>
                <Link to="/downloads" className="text-sage-200 hover:text-white text-sm transition-colors">
                  Downloads
                </Link>
              </li>
              <li>
                <a
                  href={mockData.siteInfo.socialMedia.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sage-200 hover:text-white text-sm transition-colors"
                >
                  YouTube Channel
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-sage-300 mt-0.5 flex-shrink-0" />
                <span className="text-sage-200 text-sm">{mockData.siteInfo.location}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-sage-300 mt-0.5 flex-shrink-0" />
                <a href="tel:+16047801466" className="text-sage-200 hover:text-white text-sm transition-colors">
                  {mockData.siteInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-sage-300 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@healing-women.com" className="text-sage-200 hover:text-white text-sm transition-colors">
                  {mockData.siteInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-sage-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sage-300 text-sm">
              © {currentYear} Healing-Women. All Rights Reserved.
            </p>
            <div className="flex items-center space-x-4">
              <p className="text-sage-300 text-sm">
                Created by Erwin Mayr
              </p>
              <span className="text-sage-700">•</span>
              <Link 
                to="/admin/login" 
                className="text-sage-400 hover:text-sage-200 text-xs transition-colors"
              >
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;